import Flickity from 'vue3-flickity'
import 'vue3-flickity/style'

export default defineNuxtPlugin((nuxt) => {
  nuxt.vueApp.use(Flickity)  
})